import React from 'react'

import { useCallbackStatic } from '../../hooks/utils'

import Base from './Base'

const  MeioDiaPr = () => {

    const goToMidias = useCallbackStatic(() => {
        const message = {type: 'navigate', url: 'vocenarpc://enviodemidia/1', local: 'site', version: 2.0}
        console.log(message)
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify(message)); 
        }
    })

    return (
        <Base
            title="Envie a sua mensagem para o Meio Dia Paraná!"
            description={() => (
                <span>Se quiser mandar uma foto ou vídeo <a onClick={goToMidias}>clique aqui</a></span>
            )}
            imagePath="/imgs/meiodiapr.png"
            programName="Meio Dia Paraná"
        />
    )
}

export default MeioDiaPr
